// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jf-0";
export var actionModalContentContainer = "_jf-1";
export var createTagButton = "_jf-2";
export var footerContainer = "_jf-7";
export var fullWidthDivider = "_jf-3";
export var hasCreateTagButton = "_jf-4";
export var noCreateTagButton = "_jf-5";
export var tagsContainer = "_jf-6";
export var tagsModalContentContainer = "_jf-8";